import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const AllMicroInverters: React.FC = () => {
    const { t } = useLang('theProduct.AllMicroInverters');
    return (
        <div className={styles.AllMicroInverters}>
            <EcoSectionCard
                desc={t('desc')}
                layout="center-center"
                pc="https://websiteoss.ecoflow.com/upload/image/1745584161902/%E5%85%BC%E5%AE%B9%E7%AC%AC%E4%B8%89%E6%96%B9%E5%BE%AE%E9%80%86-1-11.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1745634242626/%E5%85%BC%E5%AE%B9%E7%AC%AC%E4%B8%89%E6%96%B9%E5%BE%AE%E9%80%86-1-11%20(1).jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1745832882941/m-20250428-173347.jpeg"
                subTitle=""
                theme="white"
                title={t('title')}
            />
        </div>
    );
};

export default AllMicroInverters;
